<template>
  <div class="grid grid-nogutter text-left">
    <div class="col-12 md:col-8 map-div">
      <MapaRuta ref="map" @ready="mapReady" @mapClick="addPointToActiveRoute" />
    </div>

    <div v-if="activeMap === null" class="col-12 md:col-4 flex noprint flex-column">
      <PageHeader title="Rutas">
        <template #actions>
          <Button label="Ver" size="small" severity="secondary" outlined data-e2e="btn-ver-rutas" @click="showRoutes" />
          <Button label="Crear" size="small" data-e2e="btn-crear-ruta" @click="createRoute" />
        </template>
      </PageHeader>
      <div class="px-3">
      <div
        v-for="route in rutasStore.list"
        :key="route.id"
        @click="editRoute(route)"
      >
        <RutaDetail :doc="route" />
      </div>
      </div><!-- /px-3 -->
    </div>

    <div class="col-12 md:col-4 flex info-route flex-column p-2" v-if="activeMap !== null">
      <div class="onlyprint mt-2">
            <h2>
              {{ activeMap.name }}
            </h2>
      </div>
      <div v-if="pointType === 'route'" class="noprint">
        <h3>Buscar Lugar</h3>
        <div class="flex gap-2">
          <InputText
            v-model="address"
            placeholder="Dirección"
            style="width: 80%"
          />
          <Button
            class="p-button-success"
            icon="pi pi-search"
            @click="buscar"
          />
        </div>
      </div>

      <div
        class="mt-2 flex flex-column gap-2 line-height-3 noprint"
        v-if="pointType === 'route'"
      >
        <div class="mt-3 flex flex-column gap-2 line-height-3">
          <div class="flex gap-2 flex-wrap">
            <Button label="Guardar Ruta" size="small" @click="saveRoute" />
            <Button
              severity="secondary"
              size="small"
              label="Cancelar"
              @click="noSaveRoute"
            />
            <Button
              severity="secondary"
              size="small"
              label="Imprimir"
              @click="print"
            />
            <!-- delete route -->
            <Button severity="danger" size="small" label="Eliminar" @click="deleteRoute(activeMap)" />
          </div>

          <h3>Diseñador de Rutas</h3>

          <div>Asigna un nombre a la ruta</div>
          <InputText v-model="activeMap.name" placeholder="Nombre de Ruta" />
          <div class="font-light text-sm">
            Toca en distintos puntos del mapa para dibujar la ruta.
          </div>
        </div>
      </div>
      <div v-if="pointType !== 'route'" class="noprint"> 
        <div v-if="pointType !== 'route'">
          <Button
            class="p-button-warning"
            label="Volver a dibujar la ruta"
            icon="pi pi-arrow-left"
            @click="pointType = 'route'"
          />
        </div>
      </div>
      <RutasPoints
        v-model:pointType="pointType"
        v-model="activeMap.points"
        :latLng="activePoint"
        @refreshPoint="refreshActivePoint"
        class="mt-2"
      />

      <div v-if="pointType === 'route'">
        <h3 class="mb-3 mt-3">Logistica de la Ruta</h3>
        <div class="p-fluid">
          <label class="mb-2"
            >Vehiculos recomendados: {{ activeMap.vehicleQty }}</label
          >
          <Rating
            v-model="activeMap.vehicleQty"
            :cancel="false"
            :stars="10"
            class="mt-2"
          >
            <template #onicon>
              <i class="pi pi-car" style="color: var(--accent)"></i>
            </template>
            <template #officon>
              <i class="pi pi-car" style="color: gray"></i>
            </template>
          </Rating>
        </div>
        <div class="p-fluid mt-3">
          <label class="mb-2"
            >Publicadores recomendados por vehiculo:
            {{ activeMap.vehiclePeopleQty }}</label
          >
          <Rating
            v-model="activeMap.vehiclePeopleQty"
            :cancel="false"
            :stars="10"
            class="mt-2"
          >
            <template #onicon>
              <i class="pi pi-user" style="color: var(--accent)"></i>
            </template>
            <template #officon>
              <i class="pi pi-user" style="color: gray"></i>
            </template>
          </Rating>
        </div>
        <div class="p-fluid mt-3">
          <label for="">Observaciones:</label>
          <Textarea v-model="activeMap.notes" rows="3" class="noprint" />
          <div class="onlyprint mt-2">
            {{ activeMap.notes }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
import MapaRuta from "./MapaRuta.vue";
import RutasPoints from "./RutasPoints.vue";
import RutaDetail from "./RutaDetail.vue";
// import { Button } from "primevue/button";
// import { InputText } from "primevue/inputtext";
import Rating from "primevue/rating";
import { useRutas } from "./useRutas";
const {
  rutasStore,
  address,
  geocode,
  activeMap,
  activePoint,
  map,
  pointType,
  editRoute,
  createRoute,
  onMapReady,
  saveRoute,
  noSaveRoute,
  deleteRoute,
  showRoutes,
  addPointToActiveRoute,
  refreshActivePoint,
} = useRutas();

const mapReady = (mapValue) => {
  console.log("mapReady");
  onMapReady(mapValue);
};

const print = () => {
  window.print();
};

const buscar = async () => {
  const data = await geocode();
  console.log("buscar", data);
};
</script>

<style scoped>
h3 {
  margin: 0;
  font-weight: var(--weight-semibold);
  text-align: left;
  margin-bottom: var(--space-2);
  color: var(--label-primary);
}
h2 {
  font-weight: var(--weight-medium);
  margin: 0;
}

@media print {
  /* Aquí irían tus reglas CSS específicas para imprimir */
  .noprint {
    display: none !important;
  }
  .pageall {
    height: auto !important;
    overflow: visible !important;
  }
  .p-paginator-bottom,
  .p-column-filter {
    display: none !important;
  }

  .onlyprint {
    display: block !important;
  }
  .map-div {
    width: 100% !important;
  }
  .map-div {
    page-break-inside: avoid;
  }

  .info-route {
    order: -1;
    padding: 20px;
    width: calc(100% - 40px) !important;
    margin: 20px;
  }

}
</style>

<style>
@media print {
  .noprint {
    display: none !important;
  }
  .leaflet-control-container {
    display: none !important;
  }

  img.leaflet-marker-icon, img.leaflet-marker-shadow {
    display: none !important;
  }

}
</style>
